import {useIsFeatureActive} from '@aboutyou/feature-flags';
import {useIsProductInBasketWithFetchedFlag} from '@aboutyou/user';
import {useMemo} from 'react';
import {useBadgesListKeys} from '../../../features/BadgeList/useBadgesList';
import {useMinimalGetProductBulkBadges} from '../ProductInformationBox/MiniArticleDetail/useGetMinimalProductBulkSection';
import {useGetProductBulkBadges} from '../useGetProductBulkSection';

type UseGetBadgeListKeysType = {
  isInMiniADPDialog: boolean;
  productId?: number;
  shouldWaitForInBasketResponse?: boolean;
};

export const useGetBadgeListKeys = ({
  isInMiniADPDialog,
  productId,
  shouldWaitForInBasketResponse,
}: UseGetBadgeListKeysType) => {
  const {isActive: isPriceOverhaulV2Active} = useIsFeatureActive(
    'ab_price_display_overhaul_v2',
  );
  // we ensure to use the minimal bulk request only on the mini ADP
  const useGetBadgesRequest = isInMiniADPDialog
    ? useMinimalGetProductBulkBadges
    : useGetProductBulkBadges;

  const {badges, isFetching} = useGetBadgesRequest({
    productId: productId!,
    disabled: isInMiniADPDialog && !productId,
  });
  const saleBadgeLabel = useMemo(() => {
    return badges.reduce(
      (acc, badge) =>
        badge.type && badge.type.$case === 'sale'
          ? badge.type.sale.defaultLabel
          : acc,
      null as null | string,
    );
  }, [badges]);
  const badgesListKeysFetcherResponse = useBadgesListKeys({
    badges,
    campaignSale: null,
    sale: saleBadgeLabel,
    showPriceOverhaulV2SaleLabel: isPriceOverhaulV2Active,
    productInBasketFetcher: shouldWaitForInBasketResponse
      ? useIsProductInBasketWithFetchedFlag
      : undefined,
  });

  const badgesListKeysMemo = useMemo(
    () => badgesListKeysFetcherResponse,
    [badgesListKeysFetcherResponse],
  );

  return {
    badgesListKeys: badgesListKeysMemo,
    isFetching,
  };
};
